import { Outlet, useLocation } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import checkUserRole from "./userRoleManger";
import { DashboardContext } from "../Self-Verification Tool/DashboardContext";
import Header from "../common/Header";
 
const UserLayout = () => {
    const { t, i18n } = useTranslation(); // Include i18n to track language changes
    const [pageName, setPageName] = useState("");
    const location = useLocation();
    const { selectedDashboard } = useContext(DashboardContext);
    const [hasAccess, setHasAccess] = useState(false);

    const dashboardTranslationKeyMap = {
        "Hitachi Dashboard": "hitachiDashboard",
        "Entity Dashboard": "entityDashboard",
        "Sector Dashboard": "sectorDashboard",
        "Business Unit Dashboard": "businessUnitDashboard",
        "Sub Business Unit Dashboard": "subBusinessUnitDashboard",
        "Region Dashboard": "regionDashboard",
        "Country Dashboard": "countryDashboard"
    };

    const userPages = [
        {
            path: "self-verification",
            page: t("selfVerificationTool"),
        },
        {
            path: "dms",
            page: t("documentManagement"),
        },
        {
            path: "survey",
            page: t("surveyAwatingResponse"),
        },
        {
            path: "assessment",
            page: t("assessmentManagement"),
        },
        {
            path: "dashboard",
            page: t("dashboard"),
        },
    ];

    const isExternalUserSurvey = sessionStorage.getItem("isExternalUserSurvey");
 
    useEffect(() => {
        getPageName(location.pathname);
    }, [location, i18n.language]);
 
    const getPageName = (url) => {
        const page = url.substring(url.lastIndexOf("/") + 1);
        if (page === "dashboard") {
            if (selectedDashboard && dashboardTranslationKeyMap[selectedDashboard]) {
                setPageName(t(dashboardTranslationKeyMap[selectedDashboard]));
            } else {
                setPageName(t("hitachiDashboard"));
            }
            return;
        } else if (page === "opening-page" && sessionStorage.getItem("surveyPreview") === 'true') {
            setPageName(t("surveyPreview"));
            return;
        } else if (page === "response-page" || page === "opening-page" || page === "user-response-page" || page === "ques-page") {
            setPageName(t("survey"));
            return;
        }
        userPages.forEach((item) => {
            if (item.path === page) {
                setPageName(item.page);
            }
        });
    };
 
    if(isExternalUserSurvey === 'false' && sessionStorage.getItem("surveyPreview") !== 'true') {
        if (!checkUserRole()) {
            return <p>{t("accessDenied")}</p>;
        }
    }
 
    return (
        <div>
            <Header headerName={pageName} />
            <Outlet />
        </div>
    );
};
 
export default UserLayout;
 